export const AUTH_KEYS = {
  GET_ME: (isAuth: boolean) => ["me", isAuth],
  LOGIN: ["login"],
  LOGOUT: ["logout"],
};
